import { Box, Typography } from "@mui/material";
import placeholder from "../images/transfers-placeholder.png"; // Adjust the path as necessary

function Banner() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", pt: { xs: 2, sm: 4 }}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: { xs: "100%", sm: "90%" },
          maxWidth: "70rem",
          height: { xs: "300px", sm: "500px" },
          overflow: "hidden",
        }}
      >
        <div className="video-container" style={{ position: "relative", width: "100%", height: "100%" }}>
          <video
            src="/video.mp4"
            autoPlay={true}
            loop={true}
            muted={true}
            playsInline={true}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: "1",
            }}
          >
            Sorry, your browser doesn't support embedded videos.
          </video>
          <Box
            component="img"
            src="/logo2.png"
            alt="arrow that says See Our Designs"
            sx={{
              display: { xs: "none", sm: "block" },
              position: "absolute",
              top: "45%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "15%",
              height: "auto",
              zIndex: 2,
              filter: "drop-shadow(0 15px 24px rgba(0,0,0,0.8))",
              objectFit: "cover",
            }}
          />
          <Typography
            variant="h3"
            sx={{
              position: "absolute",
              top: { xs: "50%", sm: "80%" },
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "#fff",
              zIndex: 2,
              textShadow: "0 4px 24px rgba(0,0,0,0.9)",
              fontWeight: "bold",
              fontSize: { xs: "3rem", sm: "5rem" },
              textAlign: "center",
              width: "90%",
              pointerEvents: "none",
              textTransform: "uppercase",
              fontFamily: "Anek Latin"
            }}
          >
            DTF Made Simple
          </Typography>
        </div>
      </Box>
    </Box>
  );
}

export default Banner;
